import IFrame from "../IFrame";
import * as domHelpers from "../../scripts/utils/domHelpers.js";

class Multibuypage {
    constructor() {
        this.wrapHeader();
        this.restructureEventDivs();

        document.querySelectorAll(".Dates_Heading").forEach((element) => {
            element.remove();
        });
    }

    wrapHeader() {
        const allElements = Array.from(
            document.querySelectorAll(".OffersDiv > *"),
        );

        const headerElements = allElements.slice(
            0,
            allElements.findIndex((element) =>
                element.classList.contains("Events"),
            ),
        );

        domHelpers.wrapAll(headerElements, {
            element: "div",
            className: "spektrix-page-header",
        });
    }

    // Restructure the .Event divs into the standard card layout.
    restructureEventDivs() {
        const eventDivs = document.querySelectorAll(".Events .Event");

        eventDivs.forEach((eventDiv) => {
            const heading = eventDiv.querySelector(".Event_Name");
            const description = null; //eventDiv.querySelector(".Event_Description");
            const dates = eventDiv.querySelector(".Event_Dates");
            const image = eventDiv.querySelector(".Event_Image img");
            const moreInfoButton = eventDiv.querySelector(".More_Info");

            const cardHTML = `
                <article class="card not-prose card--event">
                    <div class="card__inner">
                        ${
                            image
                                ? `
                            <div class="card__image">
                                <div class="card__image-inner">
                                    ${image.outerHTML}
                                </div>
                            </div>
                        `
                                : ""
                        }

                        <div class="card__content stack stack--s">
                            <div class="card__header">
                                <h3 class="card__heading">${heading.textContent}</h3>
                            </div>

                            ${
                                dates
                                    ? `
                                <div class="card__meta margin-trim card__clickable">
                                    <p class="card__dates type-h6" aria-label="Dates">${dates.textContent}</p>
                                </div>
                            `
                                    : ""
                            }

                            ${
                                description
                                    ? `
                                <div class="card__summary">
                                    ${description.innerHTML}
                                </div>
                            `
                                    : ""
                            }

                            <div class="card__actions">
                                ${
                                    moreInfoButton
                                        ? `
                                    <a href="${moreInfoButton.href}" class="btn btn--transparent btn--small card__btn card__fill-link">
                                        More info
                                        <span class="sr-text">about ${heading.textContent}</span>
                                    </a>
                                `
                                        : ""
                                }
                            </div>
                        </div>
                    </div>
                </article>
            `;

            const newEventCard = document.createElement("div");
            newEventCard.innerHTML = cardHTML.trim();

            eventDiv.replaceWith(newEventCard.firstChild);
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const pageSelector = document.querySelector(".SpektrixPage.Multibuypage");

    if (pageSelector) {
        new Multibuypage();
    }
});
